import React from 'react'
import cx from 'classnames'

import s from './Dots.scss'


const Dots = ({ amount, activeIndex, onClick }) => (
  <div className={s.dots}>
    {
      Array.apply(null, new Array(amount)).map((el, index) => {
        const isActive = index === activeIndex
        const className = cx(s.dot, {
          [s.active]: isActive,
        })
        const handleClick = isActive ? null : () => onClick(index)

        return (
          <button type="button" key={index} className={className} onClick={handleClick} />
        )
      })
    }
  </div>
)

export default Dots
